import React from "react";
import { Instagram } from "lucide-react";
import { trackClick } from "../../lib/track";

const TiktokIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden {...props}>
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.83a8.16 8.16 0 0 0 4.77 1.52V6.9a4.85 4.85 0 0 1-1.84-.21Z" />
  </svg>
);

const fire = (id, href) => () => trackClick(id, href, "footer");

export default function SiteFooter() {
  return (
    <footer
      data-testid="site-footer"
      className="relative w-full bg-[#0F0F0F] border-t border-[#1A1A1A] py-16 px-6"
    >
      <div className="max-w-4xl mx-auto flex flex-col items-center gap-10 text-center">
        <p className="font-marker text-2xl sm:text-3xl text-[#E8E5DE]">
          i hate wood mulch
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-6 sm:gap-10">
          <a
            href="https://instagram.com/ihatewoodmulch"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="social-instagram"
            onClick={fire("social-instagram", "https://instagram.com/ihatewoodmulch")}
            className="flex items-center gap-3 text-sm tracking-[0.2em] uppercase text-[#A3A3A3] hover:text-[#C4451C] transition-colors"
          >
            <Instagram size={18} />
            @ihatewoodmulch on Instagram
          </a>
          <a
            href="https://tiktok.com/@ihatewoodmulch"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="social-tiktok"
            onClick={fire("social-tiktok", "https://tiktok.com/@ihatewoodmulch")}
            className="flex items-center gap-3 text-sm tracking-[0.2em] uppercase text-[#A3A3A3] hover:text-[#C4451C] transition-colors"
          >
            <TiktokIcon className="w-[18px] h-[18px]" />
            @ihatewoodmulch on TikTok
          </a>
        </div>

        <div className="section-divider w-32" />

        <p className="text-[11px] tracking-[0.25em] uppercase text-[#525252]">
          A campaign by{" "}
          <a
            href="https://recycledrubber.com/about-us/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-rr-link"
            onClick={fire("footer-rr-link", "https://recycledrubber.com/about-us/")}
            className="text-[#A3A3A3] hover:text-[#C4451C] underline underline-offset-4"
          >
            Recycled Rubber
          </a>
        </p>
        <p className="text-[10px] text-[#404040] max-w-md">
          Sources cited throughout the page reference NFPA mulch fire data, university extension
          services on artillery fungus and pests, and EPA guidance on CCA-treated lumber.
          Cost figures are estimates and may vary by region.
        </p>
      </div>
    </footer>
  );
}
